import React from 'react'
import type { ICommonLinkProps } from '@frontend/pole-ui/lib/components/CommonLink'
import { CommonLink } from '@frontend/pole-ui/lib/components/CommonLink'

export const getLinkFormatOption =
  (url: string, options: Omit<ICommonLinkProps, 'url'> = {}) =>
  (text: string) => (
    <CommonLink {...options} url={url}>
      {text}
    </CommonLink>
  )
